import React from 'react'
import WhitePlusIconSVG from "../../../assets/icons/add-dinner-plan-plus.svg"
export const WhitePlusIcon: React.FC = () => {
  return (
    <img src={WhitePlusIconSVG} alt="" className="w-[20px] h-[20px]" />
  )
}
